// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Capacitor-specific styles */

/* Safe area handling for devices with notches/camera cutouts */
@supports (padding: max(0px)) {
  .container {
    padding-left: max(16px, env(safe-area-inset-left));
    padding-right: max(16px, env(safe-area-inset-right));
    padding-top: max(32px, env(safe-area-inset-top));
    padding-bottom: max(32px, env(safe-area-inset-bottom));
  }
  
  .game-over-container {
    padding-left: max(16px, env(safe-area-inset-left));
    padding-right: max(16px, env(safe-area-inset-right));
    padding-top: max(16px, env(safe-area-inset-top));
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }
  
  .modal.native-app {
    padding-left: max(10px, env(safe-area-inset-left));
    padding-right: max(10px, env(safe-area-inset-right));
    padding-top: max(10px, env(safe-area-inset-top));
    padding-bottom: max(10px, env(safe-area-inset-bottom));
  }
  
  header h1 {
    margin-top: max(0px, env(safe-area-inset-top));
    padding-top: max(16px, env(safe-area-inset-top));
  }
}

.modal.native-app {
  background: rgba(0, 0, 0, 0.8);
}

.modal-content.native-content {
  border-radius: 16px;
}

.native-app .game-stats:not(.mobile-layout) {
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.native-app .stat {
  min-width: 120px;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e5e7eb;
}

.native-app .stat-value {
  font-size: 1.8rem;
  margin-bottom: 0.3rem;
}

.native-app .stat-label {
  font-size: 0.9rem;
}

.native-app.container {
  padding: 16px;
  padding-top: max(16px, env(safe-area-inset-top));
}

.native-app .privacy-policy-content {
  border-radius: 16px;
}

.native-app .privacy-policy-overlay {
  background: rgba(0, 0, 0, 0.8);
}

.native-app header h1 {
  font-size: 1.8rem;
  margin-top: max(8px, env(safe-area-inset-top));
}

@media (max-width: 480px) {
  .native-app header {
    margin-bottom: 1.5rem;
    margin-top: max(8px, env(safe-area-inset-top));
  }
}

@media (max-width: 768px) {
  .native-app .game-header-main {
    margin-bottom: 0.2rem !important;
  }
  .native-app .game-header-main h1 {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
}

.native-app .game-over-container {
  padding: 1rem;
  padding-top: max(1rem, env(safe-area-inset-top));
}

/* Start page specific styling for better spacing */
.native-app .difficulty-selector {
  margin-top: max(1rem, env(safe-area-inset-top));
}

/* Game over page specific styling for better spacing */
.native-app .game-over-container header h1 {
  margin-top: max(8px, env(safe-area-inset-top));
}

.native-app .game-over-container .button-container {
  margin-top: max(1.5rem, calc(1.5rem + env(safe-area-inset-top)));
}

.native-app .game-over-container .game-stats {
  margin-top: max(1rem, env(safe-area-inset-top));
}

.native-app .game-over-container .new-high-score-banner,
.native-app .game-over-container .leaderboard-banner,
.native-app .game-over-container .personal-best-banner {
  margin-top: max(1rem, env(safe-area-inset-top));
}

.native-app .button-container {
  margin-top: max(1.5rem, calc(1.5rem + env(safe-area-inset-top)));
}

.native-app.container {
  padding: 16px;
}

/* --- DEBUG: Force grid layout and full-width stat boxes for mobile layout in Capacitor app --- */

.native-app .game-stats.mobile-layout {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr) !important;
  gap: 1rem !important;
  padding: 0 1rem !important;
  width: auto !important;
  max-width: 400px !important;
  margin: 0 auto !important;
  flex-direction: unset !important;
  align-items: unset !important;
}

.native-app .game-stats.mobile-layout .timer-stat {
  grid-column: 1 / -1 !important;
  order: unset !important;
  min-width: unset !important;
  padding: 1rem 0.5rem !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  width: 100% !important;
  min-height: 80px !important;
  justify-content: center !important;
}

.native-app .game-stats.mobile-layout .bottom-row {
  display: contents !important;
  gap: unset !important;
  justify-content: unset !important;
  width: unset !important;
}

.native-app .game-stats.mobile-layout .bottom-row .stat,
.native-app .game-stats.mobile-layout .stat {
  width: 100% !important;
  box-sizing: border-box !important;
  min-width: unset !important;
  padding: 1rem 0.5rem !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  margin-bottom: 0 !important;
  min-height: 80px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.native-app .game-stats.mobile-layout .stat-value {
  font-size: 2rem !important;
  font-weight: 700 !important;
  margin-bottom: 0.3rem !important;
}

.native-app .game-stats.mobile-layout .stat-label {
  font-size: 0.75rem !important;
}

/* --- Native Landscape Layout: All 4 stats in one horizontal row --- */
.native-app .game-stats.native-landscape-layout {
  display: flex !important;
  flex-direction: row !important;
  gap: 1rem !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  max-width: none !important;
  padding: 0 1rem !important;
  margin: 0 auto !important;
}

.native-app .game-stats.native-landscape-layout .timer-stat {
  grid-column: unset !important;
  order: unset !important;
  min-width: 80px !important;
  padding: 0.7rem 1.2rem !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  width: auto !important;
  min-height: unset !important;
  justify-content: center !important;
}

.native-app .game-stats.native-landscape-layout .bottom-row {
  display: flex !important;
  gap: 1rem !important;
  justify-content: center !important;
  width: auto !important;
}

.native-app .game-stats.native-landscape-layout .bottom-row .stat,
.native-app .game-stats.native-landscape-layout .stat {
  width: auto !important;
  box-sizing: border-box !important;
  min-width: 80px !important;
  padding: 0.7rem 1.2rem !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  margin-bottom: 0 !important;
  min-height: unset !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.native-app .game-stats.native-landscape-layout .stat-value {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  margin-bottom: 0.2rem !important;
}

.native-app .game-stats.native-landscape-layout .stat-label {
  font-size: 0.85rem !important;
}

.game-stats:not(.mobile-layout) {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.game-stats:not(.mobile-layout) .stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  padding: 0.7rem 1.2rem;
  min-width: 80px;
  border: 1px solid #e5e7eb;
}

.native-app .high-scores-tabs {
  border-radius: 12px;
}

.native-app .tab-button {
  border-radius: 8px;
  font-size: 0.9rem;
  padding: 10px 16px;
}

.modal.native-app .modal-close,
.modal.native-app .info-modal-close,
.modal.native-app .close-button {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border: none;
  font-size: 1.2rem;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.mobile-modal,
.modal.native-app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
} `, "",{"version":3,"sources":["webpack://./src/styles/capacitor.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,+DAA+D;AAC/D;EACE;IACE,kDAAkD;IAClD,oDAAoD;IACpD,gDAAgD;IAChD,sDAAsD;EACxD;;EAEA;IACE,kDAAkD;IAClD,oDAAoD;IACpD,gDAAgD;IAChD,sDAAsD;EACxD;;EAEA;IACE,kDAAkD;IAClD,oDAAoD;IACpD,gDAAgD;IAChD,sDAAsD;EACxD;;EAEA;IACE,8CAA8C;IAC9C,gDAAgD;EAClD;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE;IACE,qBAAqB;IACrB,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA,mDAAmD;AACnD;EACE,+CAA+C;AACjD;;AAEA,uDAAuD;AACvD;EACE,8CAA8C;AAChD;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA,kGAAkG;;AAElG;EACE,wBAAwB;EACxB,gDAAgD;EAChD,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,iDAAiD;EACjD,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,iDAAiD;EACjD,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,uEAAuE;AACvE;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,iDAAiD;EACjD,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,iDAAiD;EACjD,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf","sourcesContent":["/* Capacitor-specific styles */\n\n/* Safe area handling for devices with notches/camera cutouts */\n@supports (padding: max(0px)) {\n  .container {\n    padding-left: max(16px, env(safe-area-inset-left));\n    padding-right: max(16px, env(safe-area-inset-right));\n    padding-top: max(32px, env(safe-area-inset-top));\n    padding-bottom: max(32px, env(safe-area-inset-bottom));\n  }\n  \n  .game-over-container {\n    padding-left: max(16px, env(safe-area-inset-left));\n    padding-right: max(16px, env(safe-area-inset-right));\n    padding-top: max(16px, env(safe-area-inset-top));\n    padding-bottom: max(16px, env(safe-area-inset-bottom));\n  }\n  \n  .modal.native-app {\n    padding-left: max(10px, env(safe-area-inset-left));\n    padding-right: max(10px, env(safe-area-inset-right));\n    padding-top: max(10px, env(safe-area-inset-top));\n    padding-bottom: max(10px, env(safe-area-inset-bottom));\n  }\n  \n  header h1 {\n    margin-top: max(0px, env(safe-area-inset-top));\n    padding-top: max(16px, env(safe-area-inset-top));\n  }\n}\n\n.modal.native-app {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.modal-content.native-content {\n  border-radius: 16px;\n}\n\n.native-app .game-stats:not(.mobile-layout) {\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n.native-app .stat {\n  min-width: 120px;\n  padding: 0.8rem 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.native-app .stat-value {\n  font-size: 1.8rem;\n  margin-bottom: 0.3rem;\n}\n\n.native-app .stat-label {\n  font-size: 0.9rem;\n}\n\n.native-app.container {\n  padding: 16px;\n  padding-top: max(16px, env(safe-area-inset-top));\n}\n\n.native-app .privacy-policy-content {\n  border-radius: 16px;\n}\n\n.native-app .privacy-policy-overlay {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.native-app header h1 {\n  font-size: 1.8rem;\n  margin-top: max(8px, env(safe-area-inset-top));\n}\n\n@media (max-width: 480px) {\n  .native-app header {\n    margin-bottom: 1.5rem;\n    margin-top: max(8px, env(safe-area-inset-top));\n  }\n}\n\n@media (max-width: 768px) {\n  .native-app .game-header-main {\n    margin-bottom: 0.2rem !important;\n  }\n  .native-app .game-header-main h1 {\n    margin-bottom: 0 !important;\n    padding-bottom: 0 !important;\n  }\n}\n\n.native-app .game-over-container {\n  padding: 1rem;\n  padding-top: max(1rem, env(safe-area-inset-top));\n}\n\n/* Start page specific styling for better spacing */\n.native-app .difficulty-selector {\n  margin-top: max(1rem, env(safe-area-inset-top));\n}\n\n/* Game over page specific styling for better spacing */\n.native-app .game-over-container header h1 {\n  margin-top: max(8px, env(safe-area-inset-top));\n}\n\n.native-app .game-over-container .button-container {\n  margin-top: max(1.5rem, calc(1.5rem + env(safe-area-inset-top)));\n}\n\n.native-app .game-over-container .game-stats {\n  margin-top: max(1rem, env(safe-area-inset-top));\n}\n\n.native-app .game-over-container .new-high-score-banner,\n.native-app .game-over-container .leaderboard-banner,\n.native-app .game-over-container .personal-best-banner {\n  margin-top: max(1rem, env(safe-area-inset-top));\n}\n\n.native-app .button-container {\n  margin-top: max(1.5rem, calc(1.5rem + env(safe-area-inset-top)));\n}\n\n.native-app.container {\n  padding: 16px;\n}\n\n/* --- DEBUG: Force grid layout and full-width stat boxes for mobile layout in Capacitor app --- */\n\n.native-app .game-stats.mobile-layout {\n  display: grid !important;\n  grid-template-columns: repeat(2, 1fr) !important;\n  gap: 1rem !important;\n  padding: 0 1rem !important;\n  width: auto !important;\n  max-width: 400px !important;\n  margin: 0 auto !important;\n  flex-direction: unset !important;\n  align-items: unset !important;\n}\n\n.native-app .game-stats.mobile-layout .timer-stat {\n  grid-column: 1 / -1 !important;\n  order: unset !important;\n  min-width: unset !important;\n  padding: 1rem 0.5rem !important;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;\n  border: 1px solid #e5e7eb !important;\n  background: #fff !important;\n  width: 100% !important;\n  min-height: 80px !important;\n  justify-content: center !important;\n}\n\n.native-app .game-stats.mobile-layout .bottom-row {\n  display: contents !important;\n  gap: unset !important;\n  justify-content: unset !important;\n  width: unset !important;\n}\n\n.native-app .game-stats.mobile-layout .bottom-row .stat,\n.native-app .game-stats.mobile-layout .stat {\n  width: 100% !important;\n  box-sizing: border-box !important;\n  min-width: unset !important;\n  padding: 1rem 0.5rem !important;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;\n  border: 1px solid #e5e7eb !important;\n  background: #fff !important;\n  margin-bottom: 0 !important;\n  min-height: 80px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: center !important;\n}\n\n.native-app .game-stats.mobile-layout .stat-value {\n  font-size: 2rem !important;\n  font-weight: 700 !important;\n  margin-bottom: 0.3rem !important;\n}\n\n.native-app .game-stats.mobile-layout .stat-label {\n  font-size: 0.75rem !important;\n}\n\n/* --- Native Landscape Layout: All 4 stats in one horizontal row --- */\n.native-app .game-stats.native-landscape-layout {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 1rem !important;\n  justify-content: center !important;\n  align-items: center !important;\n  width: 100% !important;\n  max-width: none !important;\n  padding: 0 1rem !important;\n  margin: 0 auto !important;\n}\n\n.native-app .game-stats.native-landscape-layout .timer-stat {\n  grid-column: unset !important;\n  order: unset !important;\n  min-width: 80px !important;\n  padding: 0.7rem 1.2rem !important;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;\n  border: 1px solid #e5e7eb !important;\n  background: #fff !important;\n  width: auto !important;\n  min-height: unset !important;\n  justify-content: center !important;\n}\n\n.native-app .game-stats.native-landscape-layout .bottom-row {\n  display: flex !important;\n  gap: 1rem !important;\n  justify-content: center !important;\n  width: auto !important;\n}\n\n.native-app .game-stats.native-landscape-layout .bottom-row .stat,\n.native-app .game-stats.native-landscape-layout .stat {\n  width: auto !important;\n  box-sizing: border-box !important;\n  min-width: 80px !important;\n  padding: 0.7rem 1.2rem !important;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;\n  border: 1px solid #e5e7eb !important;\n  background: #fff !important;\n  margin-bottom: 0 !important;\n  min-height: unset !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: center !important;\n}\n\n.native-app .game-stats.native-landscape-layout .stat-value {\n  font-size: 1.5rem !important;\n  font-weight: 600 !important;\n  margin-bottom: 0.2rem !important;\n}\n\n.native-app .game-stats.native-landscape-layout .stat-label {\n  font-size: 0.85rem !important;\n}\n\n.game-stats:not(.mobile-layout) {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.game-stats:not(.mobile-layout) .stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n  padding: 0.7rem 1.2rem;\n  min-width: 80px;\n  border: 1px solid #e5e7eb;\n}\n\n.native-app .high-scores-tabs {\n  border-radius: 12px;\n}\n\n.native-app .tab-button {\n  border-radius: 8px;\n  font-size: 0.9rem;\n  padding: 10px 16px;\n}\n\n.modal.native-app .modal-close,\n.modal.native-app .info-modal-close,\n.modal.native-app .close-button {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  border: none;\n  font-size: 1.2rem;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.mobile-modal,\n.modal.native-app {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
